import { useContext } from 'react';

import { HotelReviewsContext } from '../contexts/HotelReviewsContext';

import type { ReviewsStore } from '../types/hotel-reviews';

import { REVIEWS_PER_PAGE_DESKTOP } from '@hotels-hotel-detail/utils/review-service';

export const useShowFilters = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return !!(data?.totalReviewCount && data?.totalReviewCount > 5);
};

export const useFirstReviews = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.reviews?.slice(0, 3) ?? [];
};

export const useReviews = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.reviews ?? [];
};

export const useTaReview = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.reviews?.find((review) => review.partner?.id === 'h_vs') ?? null;
};

export const useReviewDetailLink = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.reviewDetailLink ?? null;
};

export const useTotalReviewCount = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.totalReviewCount ?? 0;
};

export const useTotalPage = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.totalPage ?? 1;
};

export const usePageNumber = (): number => {
  const context = useContext(HotelReviewsContext);
  const offset = context.state?.offset ?? 0;
  return Math.floor(offset / REVIEWS_PER_PAGE_DESKTOP);
};

export const useSelectedTag = () => {
  const context = useContext(HotelReviewsContext);
  const { filters } = context.state ?? {};

  return (
    filters?.find((filter) => filter.type === 'FILTER_TYPE_TAG')?.value ?? null
  );
};

export const usePartners = () => {
  const context = useContext(HotelReviewsContext);
  const { data } = context.state ?? {};
  return data?.partners ?? null;
};

export const useHotelReviewsContext: () => ReviewsStore = () => {
  const context = useContext(HotelReviewsContext);
  return {
    ...context.state,
    ...context.actions,
  } as ReviewsStore;
};
